import { Sun } from 'lucide-react';
import SectionHeader from './SectionHeader';
import { PANCHANG_TRANSLATIONS } from "../../../../languages/panchang";

interface SunMoonCalculationsProps {
    sunMoon: {
        sunrise?: string;
        sunset?: string;
        moonrise?: string;
        moonrise_day_offset?: number | null;
        moonset?: string;
        moonset_day_offset?: number | null;
        sun_sign?: string;
        moon_sign?: string;
    } | null;
    dayDuration: string | null;
    formatTime: (time: string | null | undefined, dayOffset?: number | null) => string;
    formatDuration: (duration: string | null | undefined) => string;
    language: string;
}

const SunMoonCalculations = ({
    sunMoon,
    dayDuration,
    formatTime,
    formatDuration,
    language
}: SunMoonCalculationsProps) => {
    const langKey = language === 'hindi' ? 'Hindi' : 'English';
    const t = PANCHANG_TRANSLATIONS[langKey];

    return (
        <div className="bg-white/[0.08] border border-white/20 rounded-2xl p-4 md:p-8 shadow-xl">
            <SectionHeader icon={Sun} title={t.sunMoonCalculations} />
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                {/* Sun timings */}
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.sunrise}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-yellow-400 font-sans">{formatTime(sunMoon?.sunrise)}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.sunset}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-orange-400 font-sans">{formatTime(sunMoon?.sunset)}</p>
                </div>
                {/* Moon timings */}
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.moonrise}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-slate-200 font-sans">{formatTime(sunMoon?.moonrise, sunMoon?.moonrise_day_offset) || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.moonset}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-slate-400 font-sans">{formatTime(sunMoon?.moonset, sunMoon?.moonset_day_offset) || '---'}</p>
                </div>
                {/* Signs and duration */}
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.sunSign}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-amber-400 font-sans">{sunMoon?.sun_sign || '---'}</p>
                </div>
                <div className="bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.moonSign}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-purple-300 font-sans">{sunMoon?.moon_sign || '---'}</p>
                </div>
                <div className="col-span-2 bg-white/[0.08] border border-white/20 rounded-xl p-3 md:p-4 text-center hover:bg-white/[0.12] transition-colors">
                    <p className="text-[9px] sm:text-[10px] md:text-xs text-purple-300/70 font-bold uppercase leading-tight mb-1 md:mb-2 font-sans">{t.dayDuration}</p>
                    <p className="text-sm sm:text-base md:text-lg font-bold leading-tight text-blue-300 font-sans">{formatDuration(dayDuration)}</p>
                </div>
            </div>
        </div>
    );
};

export default SunMoonCalculations;
